import { render } from "./ComponentDealership.vue?vue&type=template&id=47cd19a4"
import script from "./ComponentDealership.vue?vue&type=script&lang=js"
export * from "./ComponentDealership.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__